import { lazyLoadOnRender } from '@ms/yammer-libs-lazy';
import type { ComponentType } from 'react';

import type { BannerProps } from './types';

const MaintenanceOutageBanner = () =>
  import(/* webpackChunkName: "4-feat-maintenance-outage-banner" */ './MaintenanceOutageBanner');

const LoadableMaintenanceOutageBanner: ComponentType<BannerProps> = lazyLoadOnRender({
  loader: MaintenanceOutageBanner,
});
export default LoadableMaintenanceOutageBanner;
